import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { inject, observer } from 'mobx-react'
import { toJS } from 'mobx'
import { Formik, Form, Field } from 'formik'
import pick from 'lodash/pick'
import FormError from '@components/FormError'
import PhoneFields from '@components/Form/PhoneFields'
import EmailFields from '@components/Form/EmailFields'
import LanguageFields from '@components/Form/LanguageFields'
import Input from '@components/Form/Input'
import { Dropdown } from '@components/Form/Autocomplete'
import RichTextEditor from '@components/Form/RichTextEditor'
import Button from '@components/Button'
import { employeeApi } from '@atheneum/api'
import getEmployeeValidationSchema from './validation'

class ProfileForm extends Component {
  static propTypes = {
    employee: PropTypes.object,
    modalStore: PropTypes.object,
    staticData: PropTypes.object,
    onSaveSuccess: PropTypes.object
  }

  state = { error: null }

  handleTitleChange = (title, form) => {
    form.setFieldValue('title', title, false)
  }

  handleSubmit = (values, actions) => {
    this.saveEmployee(values)
      .then(savedEmployee => {
        this.props.onSaveSuccess(savedEmployee)
      })
      .catch(({ message }) => {
        this.setState({ error: message })
        actions.setSubmitting(false)
      })
  }

  saveEmployee = employeeData => {
    const { employee } = this.props

    const data = {
      id: employee.id,
      ...employeeData,
      languages: employeeData.languages.filter(lang => lang.id),
      address: {
        ...employeeData.address,
        phones: employeeData.address.phones.filter(phone => phone.phoneNum)
      }
    }

    return employeeApi.updateProfile(data)
  }

  render () {
    const { employee, modalStore, staticData } = this.props

    const { titles } = staticData

    return (
      <div>
        <Formik
          enableReinitialize
          initialValues={getInitialEmployeeValues(employee)}
          validationSchema={getEmployeeValidationSchema(employee)}
          onSubmit={this.handleSubmit}
          render={form => (
            <div className='expert-form'>
              <h1 className='expert-form__title'>Edit profile</h1>
              <FormError error={this.state.error} />
              <Form onSubmit={form.handleSubmit}>
                <div className='expert-form__section'>
                  <h2 className='expert-form__subtitle'>
                    Personal information
                  </h2>
                  <Field
                    name='title'
                    label='Title'
                    placeholder='Select title'
                    onChange={title => this.handleTitleChange(title, form)}
                    options={titles}
                    component={Dropdown}
                  />
                  <Field
                    name='firstName'
                    label='First name'
                    component={Input}
                  />
                  <Field name='lastName' label='Last name' component={Input} />
                </div>
                <div className='expert-form__section'>
                  <h2 className='expert-form__subtitle'>Contact information</h2>
                  <PhoneFields
                    form={form}
                    name='address.phones'
                    label='Phones'
                    phoneNotRepeating={form.errors.phoneNotRepeating}
                  />
                  <EmailFields
                    form={form}
                    primaryEmail='email'
                    additionalEmails='address.emails'
                    label='Emails'
                    emailNotRepeating={form.errors.emailNotRepeating}
                  />
                </div>
                <div className='expert-form__section'>
                  <h2 className='expert-form__subtitle'>
                    Professional profile
                  </h2>
                  <LanguageFields
                    form={form}
                    name='languages'
                    label='Languages'
                  />
                  <Field
                    name='employee.expertize'
                    label='Employee expertise'
                    toolbarRight
                    component={RichTextEditor}
                  />
                  <Field
                    name='currentPosition.positionDescription'
                    label='Position description'
                    component={Input}
                  />
                </div>
                <div className='expert-form__section expert-form__section--buttons'>
                  <Button
                    primary
                    submit
                    onClick={this.onSubmit}
                    disabled={form.isSubmitting}
                  >
                    Save
                  </Button>
                  <Button onClick={modalStore.close}>Cancel</Button>
                </div>
              </Form>
            </div>
          )}
        />
      </div>
    )
  }
}

ProfileForm.defaultProps = {
  hideButtons: true,
  showCloseIcon: true,
  shouldCloseOnOverlayClick: false
}

export default inject('modalStore', 'staticData')(observer(ProfileForm))

function getInitialEmployeeValues (employee) {
  const initialEmployeeValues = pick(toJS(employee), [
    'title',
    'firstName',
    'lastName',
    'address',
    'email',
    'languages',
    'employee.expertize',
    'currentPosition.positionDescription'
  ])

  if (!initialEmployeeValues.languages.length) {
    initialEmployeeValues.languages = [
      {
        id: null,
        name: '',
        languageToUser: {
          languageId: null,
          languageProficiencyId: null
        }
      }
    ]
  }
  return initialEmployeeValues
}
